import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

export const checkpointIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 256 256"
    width="27"
    height="27"
  >
    <path d="M122.3 10.2c-24 1.9-45.2 17.8-53.9 40.3-6.2 16.1-5.5 35 1.8 50.3 2.2 4.7 56.3 94.7 57.8 96.3.7.7 54.6-89.1 58.3-96.9 7.3-15.8 7.3-36.7 0-52.8-7.7-17.2-23.6-30.7-41.6-35.4-6.4-1.7-14.9-2.3-22.4-1.8m17.3 37.6c5.5 2.6 10.5 7.5 13.3 13.3 2 4.1 2.2 5.3 2.2 11.8-.1 8.6-1.5 12.5-6.7 18.1-4.2 4.5-7.7 6.7-13.3 8.4-9.4 2.7-20-.3-27.1-7.8-4.7-5.1-7-9.9-7.4-16.5-.5-6.7.8-11.9 4.3-17.3 3.3-5.1 7-8.2 13-10.7 6.1-2.6 15.5-2.2 21.7.7"></path>
    <path d="M58.9 215.7c-13.4 16.2-24.2 29.7-24 29.9.5.5 185.6.5 186.1 0 .2-.2-10.6-13.7-24-29.9l-24.3-29.5h-24.1v4.6h10.9l10.9.1 20.6 25 20.5 25-41.8.2c-23 .1-60.6.1-83.6 0l-41.8-.2 20.6-25 20.6-25 10.9-.1h10.9v-4.6H83.2z"></path>
  </svg>
);

export const CheckpointIcon = (
  props: Partial<CustomIconComponentProps> & { onClick?: () => void }
) => <Icon component={checkpointIcon} {...props} />;
